import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homepageLogged" }
const _hoisted_2 = { class: "mainContent flex wp1200" }
const _hoisted_3 = { class: "col2_3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "numMessages" }, "12 novih sporočil", -1)
const _hoisted_5 = { class: "col1_3" }
const _hoisted_6 = { class: "shortcuts" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_8 = { href: "#" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_10 = { href: "#" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_12 = { href: "#" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_14 = { href: "#" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_16 = { href: "#" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_18 = { href: "#" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_20 = { href: "#" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_22 = { href: "#" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_24 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedItem = _resolveComponent("FeedItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_FeedItem)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("feed.shortcuts")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("feed.mobility")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_7,
            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("feed.parking")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_9,
            _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t("feed.bus")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_11,
            _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t("feed.traffic")), 1)
          ])
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("feed.community")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_13,
            _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("feed.parking")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_15,
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("feed.parking")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_17,
            _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("feed.opinions")), 1)
          ])
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("feed.environment")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_19,
            _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t("feed.weather")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_21,
            _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.$t("feed.air")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_23,
            _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.$t("feed.waste")), 1)
          ])
        ])
      ])
    ])
  ]))
}